export default __webpack_public_path__ + "static/media/resume_afan_azmi.12fc771e.pdf";